import React from "react";
import classNames from "classnames";

import { Loader } from "@common/loader";
import { Props } from "./types";
import styles from "./styles.scss";

function Button({
  className,
  type,
  status = "none",
  children,
  isDisabled,
  press,
}: Props) {
  return (
    <button
      className={classNames(
        styles.button,
        {
          [styles.submit]: type === "submit",
          [styles.delete]: type === "delete",
          [styles.cancel]: type === "cancel",
          [styles.pending]: status === "pending",
          [styles.success]: status === "success",
          [styles.failure]: status === "failure",
          [styles.default]: status === "none" && !type && !className,
        },
        className,
      )}
      type={type === "submit" ? "submit" : "button"}
      disabled={isDisabled || status === "pending"}
      onClick={() => press && status === "none" && !isDisabled && press()}
    >
      {status === "pending" ? (
        <div className={styles.loader}>
          <Loader />
        </div>
      ) : (
        children
      )}
    </button>
  );
}

export { Button };
